module.exports = __webpack_public_path__ + "resource/img/icon_language.png?c9b217a81c16750bfed74467841397e0";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_language.png
// module id = 443
// module chunks = 36